import { createSlice } from "@reduxjs/toolkit";
import {
  getCommonFailure,
  getCommonInitialState,
  getCommonStart,
  getCommonSuccess,
} from "../utils";

const initialState = {
  agentList: getCommonInitialState(),
  agentCreate: getCommonInitialState(),
  agentUpdate: getCommonInitialState(),
  agentInvite: getCommonInitialState(),
  agentDelete: getCommonInitialState(),
};

const AgentSlice = createSlice({
  name: "agent",
  initialState,
  reducers: {
    agentListStart: (state) => {
      state.agentList = getCommonStart();
    },
    agentListSuccess: (state, action) => {
      state.agentList = getCommonSuccess(action.payload);
    },
    agentListFailure: (state, action) => {
      state.agentList = getCommonFailure(action.payload);
    },

    agentCreateStart: (state, action) => {
      state.agentCreate = getCommonStart(action.payload);
    },
    agentCreateSuccess: (state, action) => {
      state.agentCreate = getCommonSuccess(action.payload);
    },
    agentCreateFailure: (state, action) => {
      state.agentCreate = getCommonFailure(action.payload);
    },

    agentUpdateStart: (state, action) => {
      state.agentUpdate = getCommonStart(action.payload);
    },
    agentUpdateSuccess: (state, action) => {
      state.agentUpdate = getCommonSuccess(action.payload);
    },
    agentUpdateFailure: (state, action) => {
      state.agentUpdate = getCommonFailure(action.payload);
    },

    agentInviteStart: (state, action) => {
      state.agentInvite = getCommonStart(action.payload);
    },
    agentInviteSuccess: (state, action) => {
      state.agentInvite = getCommonSuccess(action.payload);
    },
    agentInviteFailure: (state, action) => {
      state.agentInvite = getCommonFailure(action.payload);
    },

    agentDeleteStart: (state, action) => {
      state.agentDelete = getCommonStart(action.payload);
    },
    agentDeleteSuccess: (state, action) => {
      state.agentDelete = getCommonSuccess(action.payload);
    },
    agentDeleteFailure: (state, action) => {
      state.agentDelete = getCommonFailure(action.payload);
    },
  },
});

export const {
  agentListFailure,
  agentListStart,
  agentListSuccess,
  agentCreateFailure,
  agentCreateStart,
  agentCreateSuccess,
  agentUpdateFailure,
  agentUpdateStart,
  agentUpdateSuccess,
  agentInviteFailure,
  agentInviteStart,
  agentInviteSuccess,
  agentDeleteFailure,
  agentDeleteStart,
  agentDeleteSuccess,
} = AgentSlice.actions;

export default AgentSlice.reducer;
